import { render, staticRenderFns } from "./BlocksPanel.vue?vue&type=template&id=5182aeed&scoped=true&"
import script from "./BlocksPanel.vue?vue&type=script&lang=js&"
export * from "./BlocksPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlocksPanel.vue?vue&type=style&index=0&id=5182aeed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182aeed",
  null
  
)

export default component.exports